var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6689 21.2884C2.96182 21.2884 1.25738 18.3724 2.58572 16.0137L8.969 4.67875C10.3259 2.26924 13.7983 2.27758 15.1437 4.69357L21.4555 16.0285C22.7688 18.387 21.0636 21.2884 18.364 21.2884L5.6689 21.2884Z",
    stroke: "white",
    strokeWidth: 1.76923
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2114 13.8647C11.7042 13.8647 11.2785 13.4824 11.2241 12.9781L10.9376 10.3227L10.8842 9.00657C10.8612 8.43886 11.3153 7.96606 11.8834 7.96606H12.5395C13.1076 7.96606 13.5617 8.43886 13.5387 9.00657L13.4853 10.3227L13.1988 12.9781C13.1444 13.4824 12.7187 13.8647 12.2114 13.8647ZM12.2114 18.8256C11.755 18.8256 11.3728 18.6664 11.065 18.3479C10.7678 18.0188 10.6191 17.6261 10.6191 17.1696C10.6191 16.7025 10.7678 16.3098 11.065 15.9913C11.3728 15.6728 11.755 15.5136 12.2114 15.5136C12.6785 15.5136 13.0607 15.6728 13.3579 15.9913C13.6551 16.3098 13.8038 16.7025 13.8038 17.1696C13.8038 17.6261 13.6551 18.0188 13.3579 18.3479C13.0607 18.6664 12.6785 18.8256 12.2114 18.8256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningReport);
export default __webpack_public_path__ + "static/media/warning_report.dbe2a6f1238fd60c2565993cc33b4b5e.svg";
export { ForwardRef as ReactComponent };